<template>
  <div class="homeArticleManagement">
    <el-dialog v-model="delShow" title="提示" width="30%">
      <span>是否删除？</span>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="delShow = false">取消</el-button>
          <el-button type="primary" @click="delItem(delCode)">删除</el-button>
        </span>
      </template>
    </el-dialog>
    <div class="theHeader">
      <div class="leftContent">
        <div v-for="(item, index) in typeList" :key="index" :class="item.type == typeValue ? 'active' : ''"
          @click="typeClick(item)">
          {{ item.name }}
        </div>
      </div>

      <div class="rightContent">
        <!-- <div class="dateWap"> -->
        <el-date-picker class="dateWap" v-model="timeValue" type="daterange" range-separator="To"
          start-placeholder="开始时间" end-placeholder="	结束时间" format="YYYY/MM/DD" value-format="YYYY-MM-DD" />
        <!-- </div> -->
        <div class="inputWap">
          <!-- <el-input
            class="inputStyle"
            v-model="input"
            placeholder="Please input"
          /> -->
          <div class="buttonStyle" @click="articleGetUserArticle()">搜索</div>
        </div>
      </div>
    </div>

    <div class="tableWtyle">
      <el-table :data="tableData" height="500" style="width: 100%" :header-cell-style="{
        background: '#F5F7FA',
        color: '#303133',
        fontWeight: '800',
      }">
        <el-table-column label="">
          <template #default="scope">
            <div>
              {{ (totalnum.page - 1) * totalnum.pageSize + (scope.$index + 1) }}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="文章标题">
          <template #default="scope">
            <div>
              {{ scope.row.name || "-" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="uniqueCode" label="哈希值" />
        <el-table-column label="创建时间">
          <template #default="scope">
            <div>
              {{ scope.row.createTime || "-" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="龙源证书发布时间" v-if="typeValue != 0 && typeValue != 1">
          <template #default="scope">
            <div>
              {{ scope.row.lyUplinkPushTime || "-" }}
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="第三方发布时间" v-if="typeValue != 0 && typeValue != 1">
          <template #default="scope">
            <div>
              {{ scope.row.uplinkPushTime || "-" }}
            </div>
          </template>
        </el-table-column> -->
        <el-table-column label="支付金额">
          <template #default="scope">
            <div>
              {{ scope.row.discountPrice || "-" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="支付时间">
          <template #default="scope">
            <div>
              {{ scope.row.payTime || "-" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="龙源证书状态">
          <template #default="scope">
            <div v-if="scope.row.uplinkType == 1 || scope.row.uplinkType == 3">
              <span>{{ scope.row.lyUplinkStatus == 0 ? '草稿箱' : scope.row.lyUplinkStatus == 1 ? '审核中' :
                  scope.row.lyUplinkStatus == 2 ? '已发布' : scope.row.lyUplinkStatus == 3 ? '审核失败' :
                    scope.row.lyUplinkStatus
              }}</span>
            </div>
            <div v-else>
              -
            </div>
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template #default="scope">
            <div>
              {{ scope.row.importFlag == 1 ? '企业付费' : '线上付费' }}
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="第三方证书状态">
          <template #default="scope">
            <div v-if="scope.row.uplinkType == 2 || scope.row.uplinkType == 3">
              <span>{{ scope.row.uplinkStatus == 0 ? '草稿箱' : scope.row.uplinkStatus == 1 ? '审核中' :
                  scope.row.uplinkStatus
                    == 2 ? '已发布' : scope.row.uplinkStatus == 3 ? '审核失败' : scope.row.uplinkStatus
              }}</span>
            </div>
            <div v-else>
              -
            </div>
          </template>
        </el-table-column> -->
        <el-table-column label="支付状态">
          <template #default="scope">
            <div v-if="scope.row.payStatus == 1">已支付</div>
            <div v-else>未支付</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template #default="scope">
              <el-button type="text"
                v-if="scope.row.isSetting"
                @click="settingWork(scope.row)">编辑</el-button>
            <!-- <div v-if="scope.row.uplinkType == 3">
              <el-button type="text"
                v-if="scope.row.uplinkStatus == 0 || scope.row.uplinkStatus == 3 || scope.row.lyUplinkStatus == 0 || scope.row.lyUplinkStatus == 3"
                @click="settingWork(scope.row)">编辑</el-button>
            </div>
            <div v-else>
              <div v-if="scope.row.uplinkStatus == 0 || scope.row.uplinkStatus == 3">
                <el-button type="text"
                  @click="settingWork(scope.row)">编辑</el-button>
              </div>
              <div v-else>
                <el-button type="text"
                @click="settingWork(scope.row)">编辑</el-button>
              </div>
            </div> -->


            <el-button type="text" @click="toView(scope.row)">查看</el-button>
            <!-- <el-button type="text">删除</el-button> -->
            <div v-if="scope.row.uplinkType == 3">

              <el-button type="text" v-if="scope.row.uplinkStatus == 2 && scope.row.lyUplinkStatus == 2"
                @click="shareFun(scope.row.uniqueCode)">预览</el-button>
            </div>
            <div v-else>
              <el-button type="text" v-if="scope.row.uplinkStatus == 2 || scope.row.lyUplinkStatus == 2"
                @click="shareFun(scope.row.uniqueCode)">预览</el-button>
            </div>
            <!-- <el-button
              type="text"
              v-if="scope.row.uplinkStatus == 0"
              @click="delItem(scope.row.contentUplinkCode)"
              >删除</el-button
            > -->
            <el-button type="text" v-if="scope.row.uplinkStatus == 0 && scope.row.lyUplinkStatus == 0"
              @click="delSet(scope.row.contentUplinkCode)">删除</el-button>
            <div v-if="scope.row.uplinkType == 3">
              <el-button type="text" v-if="scope.row.uplinkStatus == 2 && scope.row.lyUplinkStatus == 2"
                @click="copyUrl(scope.row.uniqueCode)">分享</el-button>
              <el-button type="text" v-if="scope.row.uplinkStatus == 2 && scope.row.lyUplinkStatus == 2"
                @click="pricingPageJump(scope.row)">产品定价</el-button>
            </div>
            <div v-else>
              <el-button type="text" v-if="scope.row.uplinkStatus == 2 || scope.row.lyUplinkStatus == 2"
                @click="copyUrl(scope.row.uniqueCode)">分享</el-button>
              <el-button type="text" v-if="scope.row.uplinkStatus == 2 || scope.row.lyUplinkStatus == 2"
                @click="pricingPageJump(scope.row)">产品定价</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagingComponent @handleCurrentChangeSub="noChangePagination" :currentPage="totalnum.page" :rows="totalnum.pageSize"
      :total="totalnum.total" />
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { articleGetUserArticle, articleDeleteLink } from "../api/interfaceList";
import { ElMessage } from "element-plus";

import pagingComponent from "@/components/pagingComponent/index";
export default {
  name: "homeArticleManagement",
  data() {
    return {
      delCode: '',
      delShow: false,
      timeValue: null,
      page: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      tableData: null,
      typeValue: null,
      typeList: [
        {
          name: "全部",
          type: null,
        },
        {
          name: "草稿箱",
          type: 1,
        },
        {
          name: "审核中",
          type: 2,
        },
        {
          name: "已发布",
          type: 3,
        },
        {
          name: "未通过",
          type: 4
        },
      ],
    };
  },

  computed: {
    totalnum() {
      return this.page;
    },
  },
  mounted() {
    this.articleGetUserArticle();
  },
  methods: {
    delSet(e) {
      this.delCode = e
      this.delShow = true
    },
    delItem(contentUplinkCode) {
      articleDeleteLink({
        contentUplinkCode,
      }).then((res) => {
        if (res.code == 1) {
          ElMessage({
            message: res.message,
            type: "success",
          });
          this.delShow = false;
          this.articleGetUserArticle();
        } else {
          ElMessage({
            message: res.message,
          });
        }
      });
    },
    copyUrl(value) {
      const input = document.createElement("input");
      document.body.appendChild(input);
      let url = `http://market.qikan.cn/#/articleDetails?worksCode=${value}`;
      input.setAttribute("value", url);
      input.select();
      if (document.execCommand("copy")) {
        document.execCommand("copy");
      }
      document.body.removeChild(input);
      ElMessage({
        message: "复制成功",
        type: "success",
      });
    },
    shareFun(e) {
      let url = `http://market.qikan.cn/#/articleDetails?worksCode=${e}`;
      window.open(url, "_blank");
    },
    toView(e) {
      this.$router.push({
        name: "articleDetails",
        query: { uniqueCode: e.contentUplinkCode },
      });
    },
    pricingPageJump(item) {
      this.$router.push({
        name: "roductPricing",
        query: { queryData: JSON.stringify(item) },
      });
    },
    settingWork(e) {
      Cookies.set("uniqueCode", e.contentUplinkCode);
      this.$router.push({ name: "contentChain", query: { type: "1" } });
    },
    articleGetUserArticle() {
      articleGetUserArticle({
        userCode: JSON.parse(Cookies.get("userInformation")).userCode,
        page: this.totalnum.page,
        pageSize: this.totalnum.pageSize,
        uplinkStatus: this.typeValue,
        uplinkSubmitStartTime: this.timeValue ? this.timeValue[0] : "",
        uplinkSubmitEndTime: this.timeValue ? this.timeValue[1] : "",
      }).then((res) => {
        res.data.records.map(item => {
          if (item.uplinkType == 3) {
            item.uplinkStatus == 0 || item.uplinkStatus == 3 || item.lyUplinkStatus == 0 || item.lyUplinkStatus == 3 ? item.isSetting = true : item.isSetting = false
          } else if(item.uplinkType == 1){
            item.lyUplinkStatus == 0 || item.lyUplinkStatus == 3 ? item.isSetting = true : item.isSetting = false
          }else if(item.uplinkType == 2){
            item.uplinkStatus == 0 || item.uplinkStatus == 3 ? item.isSetting = true : item.isSetting = false
          }
        })
        console.log(res.data.records)
        this.totalnum.total = res.data.pages;
        this.tableData = res.data.records;
      });
    },
    typeClick(e) {
      this.typeValue = e.type;
      this.articleGetUserArticle();
    },
    noChangePagination(res) {
      this.tableData = [];
      this.totalnum.page = res;
      console.log(this.totalnum.page);

      this.articleGetUserArticle();
    },
  },
  components: {
    pagingComponent,
  },
};
</script>
<style lang="scss" scope>
.homeArticleManagement {
  width: 1050px;
  background: #ffffff;
  border-radius: 8px;
  padding: 16px 30px;
  box-sizing: border-box;

  .tableWtyle {
    width: 100%;
    margin-top: 16px;

    div {
      width: 100%;
      text-align: center;
    }
  }

  .theHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 12px;
    border-bottom: 1px solid #f7f7f7;

    .rightContent {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .dateWap {
        width: 240px;
        margin-right: 32px;
      }

      .inputWap {
        // width: 237px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .inputStyle {
          width: 157px;
        }

        .buttonStyle {
          width: 72px;
          height: 40px;
          font-size: 13px;
          font-family: AlibabaPuHuiTiM;
          color: #ffffff;
          line-height: 40px;
          text-align: center;
          background: #008aea;
          border-radius: 6px;
          text-align: center;
          cursor: pointer;
          transition: 0.3s all;
        }

        .buttonStyle:hover {
          background: #55b2fb;
        }
      }
    }

    .leftContent {
      display: flex;
      align-items: center;

      .active {
        color: #008aea;
      }

      div {
        margin-right: 40px;
        font-size: 14px;
        font-family: AlibabaPuHuiTiM;
        color: #909399;
        cursor: pointer;
        font-weight: 800;
      }

      div:last-of-type {
        margin-right: 0;
      }
    }
  }
}
</style>
